export const ROUTE_PATH = '/parking-whitelist-groups';

export const FEATURE_NAME = 'parkingWhitelistGroupsPage';
